import { useLocation, useNavigate, useNavigationType } from 'react-router'
import { SetupMFAWebAuthn } from 'mfa'
import AccountRecoveryBase from '../../components/AccountRecoveryBase'
import { useSetupMFAWebAuthn } from '../../hooks/useSetupMFAWebAuthn'
import { LOGIN_ROOT, SETUP_MFA_ENFORCED } from '../../constants/routes'
import { LEARN_MORE_ABOUT_SECURITY_KEYS } from '../../constants/accountRecoveryLinks'
import {
  SECURITY_KEY,
  SECURITY_KEY_ANIMATION,
} from '../../constants/accountRecoveryImages'

function SetupMFAWebAuthnWrapper() {
  const navigate = useNavigate()
  const location = useLocation()
  const navigationType = useNavigationType()
  const isFromSettings = location.state?.isFromSettings ?? false
  const {
    step,
    isProcessing,
    errorCode,
    registrationData,
    credential,
    prepare,
    finish,
  } = useSetupMFAWebAuthn({ isFromSettings })

  return (
    <AccountRecoveryBase.Centered>
      <SetupMFAWebAuthn
        location={location}
        history={{ action: navigationType }}
        step={step}
        isFromSettings={isFromSettings}
        isProcessing={isProcessing}
        errorCode={errorCode}
        registrationData={registrationData}
        credential={credential}
        rootPath={LOGIN_ROOT}
        settingsPath={SETUP_MFA_ENFORCED}
        learnMoreAboutSecurityKeysUrl={LEARN_MORE_ABOUT_SECURITY_KEYS}
        securityKeyUrl={SECURITY_KEY}
        securityKeyAnimationUrl={SECURITY_KEY_ANIMATION}
        onCancel={() => navigate(-1)}
        onPrepareRegistration={prepare}
        onStartRegistration={() => {}}
        onFinishRegistration={({ credential: c }) =>
          finish({ registrationData, credential: c })
        }
      />
    </AccountRecoveryBase.Centered>
  )
}

export default SetupMFAWebAuthnWrapper
